import React from 'react';

const AdminFinancialsQBMatchModal = ({ entityType, matches, firmId, notaryEmail, onLink, onForceCreate, onClose }) => {
  const isCustomer = entityType === 'customer';
  const label = isCustomer ? 'Title Company' : 'Notary';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <div className="bg-white rounded-2xl shadow-xl border border-neutral-200 w-full max-w-lg">
        <div className="flex items-center justify-between px-6 py-4 border-b border-neutral-200">
          <h2 className="text-base font-semibold text-neutral-800">QB Match Found</h2>
          <button onClick={onClose} className="text-neutral-400 hover:text-neutral-600 text-xl leading-none">&times;</button>
        </div>

        <div className="px-6 py-4 space-y-4">
          <p className="text-sm text-neutral-600">
            We found existing QuickBooks {isCustomer ? 'customers' : 'vendors'} that may match this {label.toLowerCase()}. Choose to link to an existing record or create a new one.
          </p>

          {!isCustomer && (
            <div className="bg-blue-50 border border-blue-200 rounded-lg px-4 py-3 text-sm text-blue-800">
              Email is the best signal for vendor matching. Verify the email address before linking.
            </div>
          )}

          <div className="space-y-2 max-h-64 overflow-y-auto">
            {matches.map((m) => (
              <div key={m.qb_id} className="border border-neutral-200 rounded-lg p-3 flex items-start justify-between gap-3">
                <div className="space-y-0.5 text-sm min-w-0">
                  <div className="font-medium text-neutral-800">{m.display_name}</div>
                  <div className="text-neutral-500 text-xs">QB ID: {m.qb_id}</div>
                  {m.email && <div className="text-neutral-500 text-xs">{m.email}</div>}
                  {m.phone && <div className="text-neutral-500 text-xs">{m.phone}</div>}
                  {!isCustomer && m.vendor_1099 === false && (
                    <div className="text-amber-600 text-xs font-medium">1099 Incomplete</div>
                  )}
                </div>
                <button
                  onClick={() => onLink(m.qb_id)}
                  className="shrink-0 px-3 py-1.5 text-xs font-medium bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors"
                >
                  Link to This
                </button>
              </div>
            ))}
          </div>
        </div>

        <div className="flex justify-between gap-2 px-6 py-4 border-t border-neutral-200">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-neutral-700 bg-neutral-100 hover:bg-neutral-200 rounded-lg transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onForceCreate}
            className="px-4 py-2 text-sm font-medium text-white bg-amber-600 hover:bg-amber-700 rounded-lg transition-colors"
          >
            Create New {label} in QB
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminFinancialsQBMatchModal;
